import { useEffect, useState } from "react";

const API = "https://api.m3campus.com";

async function getCsrf() {
  const r = await fetch(`${API}/csrf/`, { credentials: "include" });
  const j = await r.json();
  return j.csrfToken;
}

export default function Carrito() {
  console.log("CARRO CARGADO"); // <- para comprobar que es este componente

  const [loading, setLoading] = useState(true);
  const [pedido, setPedido] = useState(null);
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [paying, setPaying] = useState(false);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const r = await fetch(`${API}/api/cart/`, { credentials: "include" });
      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || "No se pudo cargar carrito");
      setPedido(j.pedido);
      setItems(j.items || []);
    } catch (e) {
      setError(e.message || "Error");
      setPedido(null);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ IMPORTANTE: recargar cuando vuelves con "atrás" (bfcache)
  useEffect(() => {
    load();

    const onPageShow = () => {
      // fuerza a traer el carrito real del backend (evita ver items pagados "viejos")
      load();
    };

    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  const checkout = async () => {
    setError("");
    setPaying(true);
    try {
      const csrf = await getCsrf();
      const r = await fetch(`${API}/api/cart/checkout/`, {
        method: "POST",
        credentials: "include",
        headers: { "X-CSRFToken": csrf },
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || "No se pudo iniciar el pago");

      if (!j.checkout_url) throw new Error("El backend no devolvió checkout_url");
      window.location.href = j.checkout_url;
    } catch (e) {
      setError(e.message || "Error");
      setPaying(false);
    }
  };

  const removeItem = async (itemId) => {
    setError("");
    try {
      const csrf = await getCsrf();
      const r = await fetch(`${API}/api/cart/remove/`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json", "X-CSRFToken": csrf },
        body: JSON.stringify({ item_id: itemId }),
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.detail || "No se pudo borrar");
      await load();
    } catch (e) {
      setError(e.message || "Error");
    }
  };

  if (loading) return <div style={{ padding: 20 }}>Cargando carrito…</div>;

  return (
    <div style={{ padding: 20, maxWidth: 900 }}>
      <h2>Carrito</h2>
      {error && <div style={{ color: "crimson", marginBottom: 10 }}>{error}</div>}

      {items.length === 0 ? (
        <p>Tu carrito está vacío.</p>
      ) : (
        <>
          <div style={{ display: "grid", gap: 12 }}>
            {items.map((it) => (
              <div
                key={it.id}
                style={{
                  border: "1px solid #eee",
                  borderRadius: 12,
                  padding: 12,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <div>
                  <div style={{ fontWeight: 800 }}>{it.campus.nombre}</div>
                  <div style={{ color: "#555" }}>
                    Niño: {it.hijo.nombre} {it.hijo.apellidos || ""}
                  </div>
                  <div style={{ fontWeight: 700, marginTop: 6 }}>
                    {it.precio_unitario} {it.moneda}
                  </div>
                </div>

                <button onClick={() => removeItem(it.id)} disabled={paying}>
                  Quitar
                </button>
              </div>
            ))}
          </div>

          <div style={{ marginTop: 16, paddingTop: 12, borderTop: "1px solid #eee" }}>
            <div style={{ fontWeight: 800 }}>
              Total: {pedido?.total} {pedido?.moneda}
            </div>

            <button
              onClick={checkout}
              disabled={paying}
              style={{ marginTop: 10, padding: "10px 14px", fontWeight: 800 }}
            >
              {paying ? "Redirigiendo a Stripe..." : "Ir a pagar"}
            </button>
          </div>
        </>
      )}
    </div>
  );
}